// Third-party Imports
import { createSlice } from '@reduxjs/toolkit'

// Constants
const initialState: any = {
  title: '',
  description: '',
  desButton: '',
  isOpen: false
}

export const authenticaSuccess = createSlice({
  name: 'authenticaSuccess',
  initialState,
  reducers: {
    setAuthenticaSuccess: (state, action) => {
      state.title = action.payload.title
      state.description = action.payload.description
      state.desButton = action.payload.desButton
      state.isOpen = action.payload.isOpen
    },
    resetAuthenticaSuccess: state => {
      state.title = ''
      state.description = ''
      state.desButton = ''
      state.isOpen = false
    }
  }
})

export const { setAuthenticaSuccess, resetAuthenticaSuccess } = authenticaSuccess.actions

export default authenticaSuccess.reducer
